import { togglePlans, planSvgUnchecked, planSvgChecked, } from '../helperFunctions';
import { onePlatformBuildPlanModalDisplay, onePlatformBuildPlanTileDisplay, onePlatformBuildTermsModalDisplay, } from './onePlatformBuildPlanDisplayViews';
import AppState from '../../AppState';
/**
 * Builds the display for a one platform build plan.
 *
 * @param {string} planIdentifier - The unique identifier for the plan.
 * @param {PlanData} planData - The data for the plan.
 * @param {string[]} badges - The badges to display on the plan.
 * @param {number} price - The price of the plan.
 * @param {number} priceDiscount - The discounted price of the plan.
 * @param {(Promotion|boolean)} promotion - The promotion or boolean value indicating if there is a promotion for the plan.
 * @param {HTMLElement} serviceSelected - The selected service element.
 */
const onePlatformBuildPlanDisplay = (planIdentifier, planData, badges = [], price = 0, priceDiscount = 0, promotion, serviceSelected) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const newPlan = serviceSelected ? serviceSelected : document.createElement('div');
    const responseData = planData['data'];
    const includedData = planData['included'];
    if (responseData) {
        let attributes;
        if (Array.isArray(responseData)) {
            attributes = responseData[0]['attributes'];
        }
        else if (typeof responseData === 'object') {
            attributes = responseData['attributes'];
        }
        if (attributes) {
            const { title, field_plan_one_platform_id, field_plan_monthly_fee, field_plan_monthly_fee_discount, field_plan_speed_download, field_plan_speed_upload, field_plan_terms, field_plan_min_cost, } = attributes;
            // Look for matching discount type.
            let promoDetails;
            if (typeof promotion === 'object' && includedData) {
                promoDetails = includedData.find((entity) => entity.type === 'paragraph--promo_detail' &&
                    entity.attributes.field_promo_detail_discount_type === promotion.discountType);
            }
            const nameId = title.replace(/\s+/g, '');
            if (price < 1) {
                price = parseInt(field_plan_monthly_fee, 10);
            }
            const discount = parseInt(field_plan_monthly_fee_discount, 10);
            onePlatformBuildPlanTileDisplay(newPlan, title, nameId, planIdentifier, price, discount, field_plan_min_cost, field_plan_speed_download, field_plan_speed_upload);
            badges.forEach(badge => {
                const badgeLi = document.createElement('li');
                badgeLi.classList.add('badge');
                badgeLi.innerHTML = badge;
                newPlan.querySelector(`#offer-badges-${planIdentifier}`).appendChild(badgeLi);
            });
            const planRadio = newPlan.querySelector('.plan-radio');
            newPlan.classList.add('service-plans--service-plan');
            planRadio.innerHTML = planSvgUnchecked;
            if (serviceSelected === null) {
                context.querySelector('#service-upgrades').appendChild(newPlan);
            }
            else {
                togglePlans(newPlan, planSvgChecked, planSvgUnchecked);
            }
            newPlan.setAttribute('data-plan-identifier', planIdentifier);
            newPlan.setAttribute('data-plan-one-platform-id', field_plan_one_platform_id);
            newPlan.onclick = event => {
                togglePlans(newPlan, planSvgChecked, planSvgUnchecked);
            };
            // Construct the "More Info" modal.
            onePlatformBuildPlanModalDisplay(planData, nameId, price, discount, promoDetails);
            // Construct the "Terms and Conditions" modal.
            const parser = new DOMParser();
            // Update terms from matching Plan details paragraph.
            let planTerms = (promoDetails) ? promoDetails.attributes.field_promo_detail_terms.value : field_plan_terms.value;
            const termsValue = parser.parseFromString(planTerms, 'text/html');
            onePlatformBuildTermsModalDisplay(nameId, title, termsValue.body.innerHTML);
        }
        else {
            console.error('Invalid API response format.');
        }
    }
};
export default onePlatformBuildPlanDisplay;
